<div class="content-area">
  @if (title) {
    <h3 class="content-title">{{ title }}</h3>
  }

  <div class="summary-card">
    @if (header) {
      <div class="package-header-section">
        <div class="package-info-row">
          <div class="package-details">
            <div class="package-name">{{ header.primary }}</div>
          </div>
          @if (header.secondary) {
            <div class="package-price">{{ header.secondary }}</div>
          }
        </div>

        @if (header.metaLabel || header.metaValue || header.badgeLabel) {
          <div class="order-id-section">
            @if (header.metaLabel) {
              <span class="order-id-label">{{ header.metaLabel }}</span>
            }
            @if (header.metaValue) {
              <span class="order-id-number">{{ header.metaValue }}</span>
            }
            @if (header.badgeLabel) {
              <span class="status-chip" [ngClass]="header.badgeClass">{{ header.badgeLabel }}</span>
            }
          </div>
        }
      </div>
    }

    @if (header && rows.length > 0) {
      <div class="divider"></div>
    }

    @if (rows.length > 0) {
      <div class="purchase-info-grid">
        @for (row of rows; track $index) {
          <div class="info-row-container" [class.single-column]="row.fullWidth">
            @for (field of row.fields; track field.label) {
              <div class="info-column">
                <span class="info-label">{{ field.label }}</span>
                <span class="info-value">{{ field.value || '-' }}</span>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
